/**
 * Faixas de emblema. Fonte: handoff/dc/Emblema.dc.html (tabela `static T`),
 * confirmada por handoff/07-gamificacao.md.
 *
 * A faixa é `Math.floor(nivel / 10)` com teto em 5. Ou seja:
 *   1-9 Iniciante · 10-19 Azul · 20-29 Prata · 30-39 Ouro
 *   40-49 Platina · 50+ Diamante
 *
 * Os gradientes ficam aqui e não no tokens.json porque já existem lá como
 * `tier.*`; estas constantes só apontam para as custom properties geradas.
 * O que é local é a REGRA (qual luz, moldura e faísca cada faixa tem), que
 * é comportamento, não token.
 *
 * Divergência registrada: 04-componentes.md descreve a luz do Diamante como
 * "beam"; o .dc.html usa 'beam orbit'. O .dc.html vence.
 */

export const FAIXAS = [
  { chave: 'iniciante', nome: 'Iniciante', titulo: 'Primeiros passos', luz: 'none', texto: 'var(--lv-color-text-1)' },
  { chave: 'azul', nome: 'Azul', titulo: 'Atleta consistente', luz: 'pulse', texto: '#fff' },
  { chave: 'prata', nome: 'Prata', titulo: 'Veterano', luz: 'orbit', texto: '#fff' },
  { chave: 'ouro', nome: 'Ouro', titulo: 'Elite', luz: 'beam', texto: '#fff' },
  { chave: 'platina', nome: 'Platina', titulo: 'Lenda', luz: 'orbit pulse', texto: '#fff', moldura: true },
  { chave: 'diamante', nome: 'Diamante', titulo: 'Imortal', luz: 'beam orbit', texto: '#fff', moldura: true, faiscas: true, prisma: true },
];

/** Nível -> faixa. Teto em Diamante. */
export function faixaDoNivel(nivel) {
  const i = Math.min(5, Math.floor((Number(nivel) || 1) / 10));
  return FAIXAS[i];
}

/** Gradientes e brilho vêm dos tokens gerados (color.tier.*). */
export function coresDaFaixa(faixa) {
  return {
    externo: `var(--lv-color-tier-${faixa.chave}-outer)`,
    nucleo: `var(--lv-color-tier-${faixa.chave}-core)`,
    brilho: `var(--lv-color-tier-${faixa.chave}-glow)`,
  };
}
